import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import CtaToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const HeroHomeSettings = (settingsProps) => {
  const themeOpts = [
    { label: 'Light', value: 'light' },
    { label: 'Neutral 10', value: 'neutral10' },
    { label: 'Dark', value: 'dark' },
  ]

  const typeOpts = [
    { label: 'Default', value: 'default' },
    { label: 'Rounded', value: 'rounded' },
  ]

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="theme"
          type="select"
          options={themeOpts}
          label="Tema"
          defaultValue={defaultProps['theme']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="type"
          type="select"
          options={typeOpts}
          label="Tipo"
          defaultValue={defaultProps['type']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="viewBreadcrumbs"
          type="switch"
          label="Visualizza Briciole"
          defaultValue={defaultProps['viewBreadcrumbs']}
        />
      </ToolbarSection>
    </>
  )
}
